// src/Components/Shared/NotificationBanner.jsx
import React from "react";
import "./SystemNotificationBanner.css";

const NotificationBanner = ({ notif, onDismiss }) => {
  if (!notif) return null;

  const rawContent = notif.contentJson || notif.content_json;
  if (!rawContent) return null;

  let content;
  try {
    content = typeof rawContent === "string" ? JSON.parse(rawContent) : rawContent;
  } catch (e) {
    console.error("Failed to parse content JSON:", e);
    return <div className="notification-error">Invalid JSON</div>;
  }

  return (
    <div className="global-notification-banner notification-multi">
      <div className="notification-content">
        {content.title && <div className="notification-title">{content.title}</div>}
        {Array.isArray(content.sections) &&
          content.sections.map((section, idx) => (
            <div
              key={idx}
              className="notification-line"
              dangerouslySetInnerHTML={{ __html: section.text }}
            />
          ))}
      </div>
      {onDismiss && (
        <button className="close-btn" onClick={onDismiss}>
          ×
        </button>
      )}
    </div>
  );
};

export default NotificationBanner;
